import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { GlobalService } from 'app/services/global.service';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['../../app.component.css', './navbar.component.css'],
    providers:[ AuthService ]
})

export class NavbarComponent {

    constructor(
        public global: GlobalService,
        public auth: AuthService
    ) {

    }

    

}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts